import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { SimpleSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { Resource } from '@opentelemetry/resources';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { B3Propagator } from '@opentelemetry/propagator-b3';

const initializeTracing = () => {
    // Skip initialization in development mode
    if (!process.env.REACT_APP_OTEL_COLLECTOR_URL) {
        console.log('OpenTelemetry disabled');
        return;
    }

    try {
        const resource = new Resource({
            [SemanticResourceAttributes.SERVICE_NAME]: 'aurora-webapp-service',
            [SemanticResourceAttributes.SERVICE_VERSION]: '1.0.0',
            [SemanticResourceAttributes.DEPLOYMENT_ENVIRONMENT]: 'aurora-env'
        });


			const exporter = new OTLPTraceExporter({
				url: process.env.REACT_APP_OTEL_COLLECTOR_URL+ "/v1/traces",
				// headers: {
				// 'signoz-access-token': process.env.REACT_APP_SIGNOZ_API_KEY || '48cf4c6a-b70f-4d97-88a1-faacc4082413'
				// },
			});

			const provider = new WebTracerProvider({
					resource,
					spanProcessors: [new SimpleSpanProcessor(exporter)]
        });

        // Register the provider
        provider.register({
            contextManager: new ZoneContextManager(),
						propagator: new B3Propagator(),
        });

        const instrumentations = [
            // new DocumentLoadInstrumentation(),
            // new UserInteractionInstrumentation(),
            // new FetchInstrumentation({
            //     clearTimingResources: true,
            // }),
						// new XMLHttpRequestInstrumentation(),
					getWebAutoInstrumentations({
						// load custom configuration for xml-http-request instrumentation
						'@opentelemetry/instrumentation-xml-http-request': {
							clearTimingResources: true,
						},
					})
        ];


        // Register instrumentations
        registerInstrumentations({
            instrumentations,
            tracerProvider: provider,
        });

        console.log('OpenTelemetry initialization successful');
    } catch (error) {
        console.error('Failed to initialize OpenTelemetry:', error);
    }
};

export default initializeTracing;